import React, { useState } from "react";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { LoadingOutlined } from '@ant-design/icons';

export default function StripeCheckoutForm({ onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!stripe || !elements) {
      setError("Stripe n'est pas encore prêt.");
      return;
    }

    try {
      setLoading(true);

      const { error: submitError } = await elements.submit();

      if (submitError) {
        console.error("STRIPE SUBMIT ERROR:", submitError);
        setError(submitError.message || "Erreur de validation du paiement.");
        return;
      }

      const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: "if_required",
      });

      if (confirmError) {
        console.error("STRIPE CONFIRM ERROR:", confirmError);
        setError(confirmError.message || "Paiement refusé.");
        return;
      }

      console.log("STRIPE PAYMENT INTENT:", paymentIntent);

      if (paymentIntent?.status === "succeeded") {
        await onSuccess?.(paymentIntent);
      return;
      }

      if (paymentIntent?.status === "processing") {
        setError("Le paiement est en cours de traitement.");
        return;
      }

      if (paymentIntent?.status === "requires_payment_method") {
        setError("Le paiement a échoué. Veuillez réessayer avec une autre méthode.");
        return;
      }

      if (paymentIntent?.status === "requires_action") {
        setError("Une étape supplémentaire est requise pour finaliser le paiement.");
        return;
      }

      setError("Statut de paiement inattendu.");
    } catch (err) {
      console.error("UNEXPECTED STRIPE ERROR:", err);
      setError(err.message || "Une erreur de traitement est survenue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      {error ? (
        <p className="auth-error" style={{ marginTop: 10 }}>
          {error}
        </p>
      ) : null}

      <button
        type="submit"
        className="modal-close-button"
        disabled={!stripe || !elements || loading}
        style={{ marginTop: 16, width: "100%" }}
      >
        {loading ? <LoadingOutlined spin/> : "Payer"}
      </button>
    </form>
  );
}